import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';


export const initialValues = { isModalOpen: false, openTooltipModal: () => { }, close: () => { }, modalProps: {} };
export const TooltipModalContext = createContext(initialValues);

export const TooltipModalProvider = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalProps, setModalProps] = useState({});

  const openTooltipModal = modalProps => {
    setIsModalOpen(true);
    setModalProps(modalProps);
  };

  const close = () => {
    setIsModalOpen(false);
    setModalProps({});
  };
  return (
    <TooltipModalContext.Provider value={{ isModalOpen, openTooltipModal, close, modalProps }}>
      {children}
    </TooltipModalContext.Provider>
  );
};
TooltipModalProvider.propTypes = {
  children: PropTypes.any
};
export const useToolipModal = () => useContext(TooltipModalContext);

export const withToolipModal = WrappedComponent => {
  return function TooltipModalComponent(props) {
    return (
      <TooltipModalContext.Consumer>
        {context => <WrappedComponent {...props} tooltipModalContext={context} />}
      </TooltipModalContext.Consumer>
    );
  };
};